mini_cart_init = false;
$(document).on('mouseenter', '.basket_wrapper.has_minicart', function() {
    show_overlay();
    update_mini_cart_content();
});

$(document).on('mouseleave', '.basket_wrapper.has_minicart', function() {
    hide_overlay();
});

/*
* rebuild only if cart was empty or should be empty
* rerun on remove from cart
* add - if we are adding product to cart
*/

function update_mini_cart_content(rerun = false, content = false, add = false){
    let rebuild = false;

    if(content){
        if(add){
            if($('.js-cart-count-badge').first().text() > 0){
                rebuild = true;
            }
        }else{
            if($('.js-cart-count-badge').first().text() == 0){
                rebuild = true;
                mini_cart_init = true;
            }
        }
        if(rebuild){
            let mini_cart_html = $('.basket_wrapper', content);
            $('.basket_wrapper').replaceWith(mini_cart_html);
        }
    }
    if (!add && !rebuild && (!mini_cart_init || rerun) ) {
        mini_cart_init = true;
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action': 'get_mini_cart_content'
            },
            success: function (response) {
                let data = $.parseJSON(response);
                $('.js-mini-cart-products').html(data.products);
                $('.js-mini-cart-shipping').html(data.shipping);
                $('.js-mini-cart-total').html(data.total_price);
            }
        });
    }
}

function update_mini_cart_count(result = false){
    if(result){
        let cart_count_badge = $('.js-cart-count-badge', result).first();
        $('.js-cart-count-badge').replaceWith(cart_count_badge);
        let basket_icon_wrapper = $('.basket_icon_wrapper', result).first();
        $('.basket_icon_wrapper').replaceWith(basket_icon_wrapper);
    }else{
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action': 'get_mini_cart_count'
            },
            success: function (cart_count) {
                $('.js-cart-count-badge').text(cart_count);
            }
        });
    }
}
